<template>
  <div v-if="tabelaVisivel">
    <div class="text-center" v-if="loadingTabela">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-else>
      <b-table
        responsive="sm"
        :items="itemsTabela"
        :fields="fieldsTabela"
        per-page="10"
        bordered
        striped
      >
        <template #cell(interacao)="data">
          <div class="d-flex justify-content-end">
            <b-button
              size="sm"
              variant="primary"
              class="me-1"
              v-b-tooltip.hover="'Editar'"
              @click="editarEndereco(data.item)"
              :disabled="loadingAcoes"
            >
              <i class="mdi mdi-pencil"></i>
            </b-button>
            <b-button
              size="sm"
              variant="danger"
              v-b-tooltip.hover="'Excluir'"
              :disabled="loadingAcoes"
              @click="excluirEndereco(data.item)"
            >
              <i class="mdi mdi-trash-can"></i>
              <b-spinner
                variant="primary"
                small
                class="ms-2"
                v-if="loadingAcoes"
              ></b-spinner>
            </b-button>
          </div>
        </template>
      </b-table>
      <div class="row align-items-center">
        <div class="col-md-10 text-center" v-if="!loadingTabela && !itemsTabela.length">
          <span class="fs-6 text-secondary"
            >Nenhum endereço cadastrado para este cliente rural.</span
          >
        </div>
        <div
          :class="[
            itemsTabela.length > 0
              ? 'col-12 d-flex justify-content-end'
              : 'col-md-2 d-flex justify-content-end',
          ]"
        >
          <b-button variant="info" @click="incluirEndereco">
            <i class="fa fa-solid fa-plus me-2"></i>
            <span>Incluir</span>
          </b-button>
        </div>
      </div>
    </div>
  </div>

  <div v-else>
    <div class="row">
      <div class="col-md-2">
        <b-form-group class="mb-3" label="CEP" invalid-feedback="Digite um CEP válido">
          <b-form-input
            type="text"
            v-model="cep"
            maxlength="9"
            autocomplete="off"
            v-mask="'#####-###'"
            :state="state('cep')"
            @input="consultaCep()"
          />
        </b-form-group>
      </div>

      <div
        v-if="loadingCep"
        class="col-md-8 d-flex align-items-center justify-content-center mt-3"
      >
        <div class="spinner-border text-primary" role="status"></div>
      </div>

      <div class="col-md-5" v-if="this.mostraMunicipio">
        <b-form-group
          class="mb-3"
          label="Município - UF"
          invalid-feedback="Campo obrigatório"
        >
          <b-form-input
            type="text"
            v-model="municipioUf"
            :disabled="!cepSimples"
            :state="state('municipioUf')"
          />
        </b-form-group>
      </div>
      <div class="col-md-5" v-if="this.mostraMunicipio">
        <b-form-group class="mb-3" label="Bairro" invalid-feedback="Campo obrigatório">
          <b-form-input
            v-model="dsBairro"
            :disabled="!cepSimples"
            type="text"
            :state="state('dsBairro')"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4" v-if="this.mostraMunicipio">
        <b-form-group
          class="mb-3"
          label="Logradouro"
          :state="state('selectTipLog')"
          invalid-feedback="Campo obrigatório"
        >
          <multiselect
            :show-labels="true"
            v-model="selectTipLog"
            placeholder="Selecione"
            :disabled="!cepSimples"
            :options="optionsTipLog"
            label="ds_tipo_logradouro"
          />
        </b-form-group>
      </div>
      <div class="col-md-6" v-if="this.mostraMunicipio">
        <b-form-group class="mb-3" label="Endereço" invalid-feedback="Campo obrigatório">
          <b-form-input
            type="text"
            v-model="dsEndereco"
            :disabled="!cepSimples"
            :state="state('dsEndereco')"
          />
        </b-form-group>
      </div>
      <div class="col-md-2" v-if="this.mostraMunicipio">
        <b-form-group class="mb-3" label="Número" invalid-feedback="Campo obrigatório">
          <b-form-input
            trim
            type="text"
            maxlength="8"
            autocomplete="off"
            v-model="nrEndereco"
            placeholder="Ex: 1A23C"
            class="nr-endereco-input"
            :state="state('nrEndereco')"
            @input="validarNumeroEndereco"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" v-if="this.mostraMunicipio">
        <b-form-group class="mb-3">
          <template #label>
            <div class="d-flex align-items-center">
              <span>Complemento</span>
              <span class="fw-bolder ms-1" style="font-size: 11px">(Opcional)</span>
            </div>
          </template>
          <b-form-input
            trim
            type="text"
            maxlength="50"
            v-model="dsComplemento"
            placeholder="Ex: Apartamento 101, Bloco B, etc."
          ></b-form-input>
          <div class="text-center">
            <p
              v-if="dsComplemento"
              class="badge position-absolute"
              :class="{
                'bg-success': dsComplemento.length !== 50,
                'bg-danger': dsComplemento.length === 50,
              }"
            >
              {{ dsComplemento.length }} / 50
            </p>
          </div>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div>
          <b-form-checkbox
            plain
            value="S"
            id="checkbox-1"
            unchecked-value="N"
            v-model="enderecoPrincipal"
            :disabled="disabledPrincipal == true"
          >
            Endereço Principal
          </b-form-checkbox>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div
        class="col-md-12 d-flex justify-content-between align-items-end"
        :style="{ height: '70px' }"
      >
        <b-button
          @click="voltar"
          variant="secondary"
          data-tooltip="Voltar"
          data-tooltip-location="bottom"
        >
          <i class="mdi mdi-arrow-left-circle font-size-15"></i>
        </b-button>
        <b-button
          @click="salvar"
          variant="success"
          data-tooltip="Salvar"
          data-tooltip-location="bottom"
          :disabled="loadingSalvar || !desabilitaBotaoSalvar"
        >
          <i class="mdi mdi-content-save font-size-15"></i>
          <span
            v-if="loadingSalvar"
            class="spinner-border spinner-border-sm mx-1"
            role="status"
          />
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";
import { isCheckboxDisabled } from "@/utils/astec/validaContatoPrincipal";

const capitalizeString = (str) => {
  return str
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};
export default {
  mixins: [clienteRuralMixin],
  components: {
    Multiselect,
  },
  data() {
    return {
      loadingCep: false,
      tabelaVisivel: true,
      loadingTabela: true,
      loadingSalvar: false,
      submit: false,
      mostraMunicipio: false,
      cdIbge: "",
      dsEndereco: "",
      selectTipLog: {},
      cep: "",
      municipioUf: "",
      dsBairro: "",
      cdTipoLogradouro: "",
      cdTipo: "2",
      nrEndereco: "",
      dsComplemento: "",
      enderecoPrincipal: "",
      itemsTabela: [],
      cepSimples: false,
      loadingAcoes: false,
      fieldsTabela: [
        {
          key: "NRCEP",
          label: "CEP",
          formatter: (value) => {
            return value.replace(/(\d{5})(\d{3})/, "$1-$2");
          },
        },
        {
          key: "SQREGIAO",
          label: "Município",
          formatter: (value) => {
            const municipio = this.selecaoMunicipioLkp.find(
              (el) => el.value == parseInt(value)
            );
            return municipio ? municipio.name : "N/A";
          },
        },
        {
          key: "CDTIPOLOGRADOURO",
          label: "Logradouro",
          formatter: (value) => {
            const logradouro = this.optionsTipLog.find(
              (el) => el.cd_tipo_logradouro === value
            );
            return logradouro ? logradouro.ds_tipo_logradouro : "N/A";
          },
        },
        {
          key: "DSENDERECO",
          label: "Endereço",
        },
        {
          key: "NRENDERECO",
          label: "N°",
        },
        {
          key: "STPRINCIPAL",
          label: "Principal",
          formatter: (value) => {
            return value === "S" ? "Sim" : "Não";
          },
        },
        {
          key: "interacao",
          class: "alinharCelulaDireita",
          label: "Ações",
        },
      ],
      sqEndereco: null,
      sqCliente: null,
      optionsTipLog: [],
      disabledPrincipal: "",
      selecaoMunicipioLkp: [],
      cdCooperado: null,
    };
  },

  computed: {
    desabilitaBotaoSalvar() {
      const camposPreenchidos =
        this.cep &&
        this.municipioUf &&
        this.dsBairro &&
        this.selectTipLog &&
        this.dsEndereco &&
        this.nrEndereco;

      const validacaoOk = !this.$v.$invalid;
      return (camposPreenchidos && validacaoOk) || this.loadingSalvar;
    },
    nrEnderecoFeedback() {
      if (!this.nrEndereco || !this.nrEndereco.trim()) {
        return "Campo obrigatório";
      }
      return "";
    },
  },

  created() {
    this.buscarTipLog();
    this.buscarMunicipioUf();
    this.verificarClienteRuralAstec();
  },

  methods: {
    state(param) {
      if (param === "nrEndereco" && this.mostraMunicipio) {
        if (!this.nrEndereco || this.nrEndereco.trim() === "") {
          return false;
        }
        return !this.$v.nrEndereco.$invalid;
      }
      if (this.submit || this.$v[param].$dirty) {
        return !this.$v[param].$invalid;
      } else {
        return null;
      }
    },

    async verificarClienteRuralAstec() {
      if (this.$store.state.clienteRuralAstec) {
        this.cdCooperado = this.$store.state.filtroClienteRuralAstec.cdCooperado ?? null;
        this.sqCliente = this.$store.state.clienteRuralAstec.ID ?? null;
        if (!this.sqCliente) {
          this.sqCliente = this.$store.state.clienteRuralAstec.dados.sq_cliente ?? null;
        }
        this.buscarTabelaEnderecoAstec();
      }
    },

    async buscarTabelaEnderecoAstec() {
      try {
        this.loadingTabela = true;
        const response = await this.$http.get(
          "api/astec/getClienteRuralEndereco/" + this.sqCliente + "/" + this.cdCooperado
        );
        this.itemsTabela = response.data;
        this.$emit("visibilidade-botao", true);
      } catch (error) {
        console.error("Erro ao buscar os contatos:", error);
      } finally {
        this.loadingTabela = false;
      }
    },

    buscarTipLog() {
      this.$http.get("api/cadastroCandidato/buscarTipLog").then((response) => {
        this.optionsTipLog = response.data;
      });
    },

    incluirEndereco() {
      this.tabelaVisivel = false;
      this.mostraMunicipio = false;
      this.sqEndereco = null;
      this.dsEndereco = null;
      this.cep = null;
      this.dsBairro = null;
      this.nrEndereco = null;
      this.selectTipLog = null;
      this.dsComplemento = null;
      this.municipioUf = null;
      this.cdIbge = null;
      if (this.itemsTabela.length == 0) {
        this.enderecoPrincipal = "S";
        this.disabledPrincipal = true;
        console.log("1");
      } else {
        this.enderecoPrincipal = "N";
        this.disabledPrincipal = false;
        console.log("2");
      }
      this.$emit("visibilidade-botao", false);
    },

    async editarEndereco(item) {
      this.tabelaVisivel = false;
      this.$emit("visibilidade-botao", false);
      this.mostraMunicipio = true;
      this.cep = item.NRCEP;
      this.nrEndereco = item.NRENDERECO;
      this.enderecoPrincipal = item.STPRINCIPAL === "S" ? "S" : "N";
      this.disabledPrincipal = false;
      this.sqEndereco = item.SQENDERECO;
      this.dsComplemento = item.DSCOMPLEMENTO;
      this.dsEndereco = item.DSENDERECO;
      this.dsBairro = item.DSBAIRRO;
      this.selectTipLog = this.optionsTipLog.find(
        (el) => el.cd_tipo_logradouro === item.CDTIPOLOGRADOURO
      );

      // Carrega o município/UF e o código IBGE
      const municipio = this.selecaoMunicipioLkp.find(
        (el) => el.value == parseInt(item.SQREGIAO)
      );
      this.municipioUf = municipio ? municipio.name : "N/A";

      // Se já tiver o código IBGE no item, usa ele (mais eficiente)
      if (item.CDIBGE) {
        this.cdIbge = item.CDIBGE;
      } else {
        // Se não tiver, faz a consulta do CEP para buscar o IBGE
        await this.consultaCep(true); // Passa 'true' para modo edição
      }
      this.disabledPrincipal = isCheckboxDisabled(this.enderecoPrincipal);
    },

    consultaCep(isEditing = false) {
      this.loadingCep = true;
      var cep = this.cep;
      cep = cep.replace("-", "");

      if (cep.length >= 8) {
        axios
          .get(`https://viacep.com.br/ws/${cep}/json/`)
          .then((response) => {
            if (response.data.erro) {
              this.mostraMunicipio = false;
              return;
            }

            // Sempre atualiza o código IBGE
            this.cdIbge = response.data.ibge;

            // Só atualiza outros campos se NÃO for edição
            if (!isEditing) {
              this.mostraMunicipio = true;
              const aux = response.data;
              this.municipioUf = `${capitalizeString(aux.localidade)} - ${aux.uf}`;
              this.dsBairro = aux.bairro;

              if (aux.logradouro) {
                this.cepSimples = false;
                this.separarLogradouroDeEndereco(aux.logradouro);
              } else {
                this.cepSimples = true;
              }
              this.$nextTick(() => {
                if (this.mostraMunicipio) {
                  this.$v.nrEndereco.$touch();
                }
              });
            }
          })
          .catch(() => {})
          .finally(() => {
            this.loadingCep = false;
          });
      }
    },
    separarLogradouroDeEndereco(item) {
      const tipoLogradouro = item.split(" ")[0];
      const dsEndereco = item.split(" ").slice(1).join(" ");
      this.dsEndereco = dsEndereco;
      this.selectTipLog = this.optionsTipLog.find(
        (el) => el.ds_tipo_logradouro.toLowerCase() === tipoLogradouro.toLowerCase()
      );
    },

    voltar() {
      this.sqEndereco = null;
      this.tabelaVisivel = true;
      this.disabledPrincipal = false;
      this.$emit("visibilidade-botao", true);
    },

    excluirEndereco(item) {
      Swal.fire({
        title: "Tem certeza?",
        text:
          "Você realmente deseja excluir este Endereço de cliente rural? Essa ação não pode ser desfeita.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.loadingAcoes = true;
          var obj = {
            sqCliente: this.sqCliente,
            sqEndereco: item.SQENDERECO,
          };
          this.$http
            .post("/api/astec/deletarEnderecoClientesRurais", obj)
            .then(() => {
              Swal.fire({
                icon: "success",
                title: "Sucesso",
                text: "Endereço de cliente rural excluído com sucesso!",
              });
              this.verificarClienteRuralAstec();
            })
            .catch((err) => {
              this.$tools.alerta(err.response.data, "error");
            })
            .finally(() => {
              this.loadingAcoes = false;
            });
        }
      });
    },

    async salvar() {
      this.loadingSalvar = true;
      this.submit = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loadingSalvar = false;
        return;
      }

      const obj = {
        sqCliente: this.sqCliente,
        dsEndereco: this.dsEndereco,
        nrCep: this.cep.replace("-", ""),
        dsBairro: this.dsBairro,
        nrEndereco: this.nrEndereco,
        cdTipoLogradouro: this.selectTipLog.cd_tipo_logradouro,
        dsComplemento: this.dsComplemento,
        stPrincipal: this.enderecoPrincipal === "S" ? "S" : "N",
        sqEndereco: this.sqEndereco ?? null,
        cdIbge: this.cdIbge,
      };
      try {
        await this.$http.post("api/astec/insertClienteRuralEndereco", obj);
        this.$tools.alerta("Cadastrado com sucesso", "success");
        this.tabelaVisivel = true;
        this.verificarClienteRuralAstec();
        this.$emit("enableTab", "projetos");
      } catch (err) {
        this.$tools.alerta(err.response.data, "error");
      } finally {
        this.loadingSalvar = false;
      }
    },

    validarNumeroEndereco() {
      this.nrEndereco = this.nrEndereco.trim();
      this.$v.nrEndereco.$touch();
    },
  },
  validations: {
    cep: { required },
    municipioUf: { required },
    dsBairro: { required },
    selectTipLog: { required },
    dsEndereco: { required },
    nrEndereco: { required },
  },
};
</script>
